export default __webpack_public_path__ + "static/media/c34c630cbd7ab0bb781d5d2371c52f2d1580480552015.c62979e0.webp";